module.exports = __webpack_public_path__ + "img/dashboard.28d53b3f.svg";